import { render, staticRenderFns } from "./CoursesettlementDatails.vue?vue&type=template&id=03b1a106&scoped=true"
import script from "./CoursesettlementDatails.vue?vue&type=script&lang=js"
export * from "./CoursesettlementDatails.vue?vue&type=script&lang=js"
import style0 from "./CoursesettlementDatails.vue?vue&type=style&index=0&id=03b1a106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b1a106",
  null
  
)

export default component.exports